import { keepPreviousData, useQuery } from '@tanstack/react-query';

import { QueryPagination, createQueryOptions } from '../../query';
import { useOfferApi } from '../../src/offers/api';
import { offerKeys } from '../query-key-factory';
import { MerchantSearch } from './merchants.search.types';
import {
  GetMerchantsRequest,
  MerchantSearchResponse,
  ShowMerchantResponse,
} from './merchants.types';

const useListMerchants = ({
  queryOptions,
  pagination,
}: {
  queryOptions?: MerchantSearch;
  pagination?: QueryPagination;
}) => {
  const OfferApi = useOfferApi();

  const { queryString, queryObject, queryPagination } = createQueryOptions<MerchantSearch>({
    search: queryOptions,
    pagination,
  });

  const getMerchants = async (context: GetMerchantsRequest) => {
    const { queryString } = context.meta || {};
    const { data } = await OfferApi.get<MerchantSearchResponse>(`/merchants?${queryString}`);
    return data;
  };

  const key = offerKeys.merchants.all;

  return useQuery({
    queryKey: [...key, queryObject, queryPagination],
    queryFn: getMerchants,
    meta: { queryString },
    placeholderData: keepPreviousData,
  });
};

const useShowMerchant = ({ merchantId }: { merchantId?: string }) => {
  const OfferApi = useOfferApi();

  const getMerchant = async () => {
    const { data } = await OfferApi.get<ShowMerchantResponse>(`/merchants/${merchantId}`);
    return data.merchant;
  };

  const queryKey = merchantId ? offerKeys.merchants.id(merchantId).detail : [];

  return useQuery({
    queryKey: queryKey,
    queryFn: getMerchant,
  });
};

export { useListMerchants, useShowMerchant };
